import React from 'react';
import { IZI, LOCATIONS } from '../data/site';
import { PHOTO } from '../data/media';
import Reveal, { RevealWords } from './Reveal';
import { ArrowRight, Bag, Starburst } from './Icons';
import './OrderBand.css';

const StoreBadge = ({ href, store, sub }) => (
  <a className="storebadge" href={href} target="_blank" rel="noopener noreferrer">
    <span className="storebadge__icon" aria-hidden="true">
      {store === 'ios' ? (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M16.4 12.7c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.9-3.5.9s-1.8-.8-3-.8c-1.5 0-2.9.9-3.7 2.3-1.6 2.7-.4 6.8 1.1 9 .8 1.1 1.7 2.3 2.9 2.2 1.2 0 1.6-.7 3-.7s1.8.7 3 .7 2-1.1 2.8-2.2c.9-1.2 1.2-2.4 1.3-2.5-.1 0-2.5-1-2.5-3.6ZM14.2 5.9c.6-.8 1.1-1.9 1-3-.9 0-2.1.6-2.8 1.4-.6.7-1.2 1.8-1 2.9 1 .1 2.1-.5 2.8-1.3Z" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true">
          <path d="M4.3 2.5 14.6 12 4.3 21.5A1.7 1.7 0 0 1 3.6 20V4a1.7 1.7 0 0 1 .7-1.5Zm11.9 6.7 2.6-1.5-4.1-2.3-2.4 2.2 3.9 1.6Zm0 5.6-3.9 1.6 2.4 2.2 4.1-2.3-2.6-1.5Zm4.3-3.9-2.2-1.3-2.7 2.4 2.7 2.4 2.2-1.3a1.4 1.4 0 0 0 0-2.2Z" />
        </svg>
      )}
    </span>
    <span className="storebadge__text">
      <small>{sub}</small>
      <strong>{store === 'ios' ? 'App Store' : 'Google Play'}</strong>
    </span>
  </a>
);

/** Dark "order on Izi" section — used on Home and Menus. */
export default function OrderBand({ compact = false }) {
  return (
    <section className={`orderband section--dark grain${compact ? ' is-compact' : ''}`}>
      <div className="orderband__glow" aria-hidden="true" />

      <div className="page orderband__inner on-dark">
        <div className="orderband__copy stack stack-md">
          <Reveal as="p" className="eyebrow">
            Delivery &amp; collection
          </Reveal>
          <h2 className="display d2">
            <RevealWords text="Not coming in? We will come to you." />
          </h2>
          <Reveal as="p" className="lead" delay={0.15}>
            {IZI.blurb}
          </Reveal>

          <Reveal className="orderband__actions" delay={0.25}>
            <a className="btn btn--gold" href={IZI.web} target="_blank" rel="noopener noreferrer">
              <Bag size={15} />
              <span>Order on {IZI.brand}</span>
              <ArrowRight />
            </a>
          </Reveal>

          <Reveal className="orderband__badges" delay={0.32}>
            {IZI.ios ? <StoreBadge href={IZI.ios} store="ios" sub="Download on the" /> : null}
            {IZI.android ? <StoreBadge href={IZI.android} store="android" sub="Get it on" /> : null}
          </Reveal>

          <Reveal className="orderband__branches" delay={0.38}>
            {LOCATIONS.map((loc) => (
              <span key={loc.id} className="orderband__branch">
                <Starburst size={13} spokes={12} />
                Delivering from {loc.name}
              </span>
            ))}
          </Reveal>
        </div>

        {!compact ? (
          <ol className="orderband__steps">
            {IZI.steps.map((s, i) => (
              <Reveal as="li" className="orderband__step" key={s.n} delay={0.1 + i * 0.1}>
                <span className="orderband__n tabular">{s.n}</span>
                <div>
                  <h3 className="orderband__step-title">{s.title}</h3>
                  <p className="orderband__step-body">{s.body}</p>
                </div>
              </Reveal>
            ))}
            <Reveal as="li" className="orderband__plate" delay={0.4}>
              <div className="frame frame--3x2 frame--hover">
                <img src={PHOTO.burger} alt="" loading="lazy" />
              </div>
            </Reveal>
          </ol>
        ) : null}
      </div>
    </section>
  );
}
